import { ReactNode } from "react";
import * as S from "./styles";

interface SplitScreenLayoutProps {
  children: ReactNode;
  rightContent?: ReactNode;
}

export default function SplitScreenLayout({
  children,
  rightContent,
}: SplitScreenLayoutProps) {
  return (
    <S.Container>
      <S.Header>
        <img src="/media/logos/logo.svg" alt="Logo Jusfy" />
      </S.Header>
      <S.Wrapper>
        <S.Section>{children}</S.Section>
        {rightContent}
      </S.Wrapper>
    </S.Container>
  );
}
